import { MenuItem, Select, Typography } from "@mui/material";
import { MapContext } from "../../../contexts/MapFilterContext";
import { classes } from "../classes";
import { FormControl } from "@material-ui/core";
import DropdownIcon from "../../DropdownIcon";
import { useContext } from "react";

export default function StepStatus() {
    const {
        stepStatus, setStepStatus
    } = useContext(MapContext);

    return (
        <>
            <Typography style={classes.labelInput}>
                Etapa dos Status:
            </Typography>
            <FormControl variant="outlined" style={classes.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={stepStatus}
                    onChange={(e) => { setStepStatus(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="Abertura">Abertura</MenuItem>
                    <MenuItem value="Homologação">Homologação</MenuItem>
                    <MenuItem value="Execução">Execução</MenuItem>
                    <MenuItem value="Conclusão">Conclusão</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}